import { FONTS, COLORS } from '../../../../constants';

const styles = theme => {
  const minMd = theme.breakpoints.up('md');

  return {
    root: {
      backgroundColor: COLORS.WHITE,
    },
    inner: {
      margin: '0 auto',
      maxWidth: 1200,
      padding: '20px 20px',
      [minMd]: {
        padding: '40px 30px',
      },
    },
    heading: {
      fontFamily: FONTS.SECONDARY,
      marginTop: 0,
      fontWeight: 300,
      textAlign: 'center',
      fontSize: '1.5rem',
      [minMd]: {
        fontSize: '2.25rem',
        textAlign: 'left',
      },
    },
    main: {
      [minMd]: {
        display: 'flex',
      },
    },
    leftCol: {
      [minMd]: {
        width: '50%',
      },
    },
    rightCol: {
      [minMd]: {
        width: '50%',
      },
    },
    leftColFirstRow: {
      fontSize: '1.25rem',
      fontWeight: 300,
      marginBottom: 10,
      textAlign: 'center',
      [minMd]: {
        textAlign: 'left',
        fontSize: '1.75rem',
        fontFamily: FONTS.SECONDARY,
        marginTop: 30,
        marginBottom: 20,
      },
    },
    leftColSecondRow: {
      textAlign: 'center',
      fontWeight: 300,
      fontFamily: FONTS.SECONDARY,
      fontSize: '0.75rem',
      [minMd]: {
        textAlign: 'left',
        fontSize: '0.875rem',
        paddingRight: 20,
      },
      '& a': {
        color: COLORS.GREEN,
        textDecoration: 'none',
      },
    },
  };
};

export default styles;
